var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('section',[_c('h2',[_vm._v("Page Not Found")]),_c('p',[_vm._v("The page that you requested could not be found.")]),_c('h3',[_c('router-link',{attrs:{"to":"/"}},[_vm._v(" Return to the home page ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }